import { createStars, createNebula } from "./shared"
import * as THREE from 'three'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'

import { RectAreaLightHelper } from 'three/addons/helpers/RectAreaLightHelper.js'
import { RectAreaLightUniformsLib } from 'three/addons/lights/RectAreaLightUniformsLib.js'

import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js'
import { FilmPass } from 'three/addons/postprocessing/FilmPass.js'
import { OutlinePass } from 'three/addons/postprocessing/OutlinePass.js'
import { RenderPixelatedPass } from 'three/addons/postprocessing/RenderPixelatedPass.js'
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js'

import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

let outlineEnabled = false
let effectOutline

export default function minting() {
  // Set up THREEJS scene
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  }
  const scene = new THREE.Scene()
  const camera = new THREE.PerspectiveCamera( 75, sizes.width / sizes.height, 0.1, 1000 )

  const renderer = new THREE.WebGLRenderer()
  renderer.setSize( sizes.width, sizes.height )
  renderer.setPixelRatio( window.devicePixelRatio )
  renderer.antialias = true
  document.body.appendChild( renderer.domElement )

  const controls = new OrbitControls( camera, renderer.domElement )
  controls.maxDistance = 250
  controls.minDistance = 0.1
  
  camera.position.x = $fx.getParam("positionX")
  camera.position.y = $fx.getParam("positionY")
  camera.position.z = $fx.getParam("positionZ")

  camera.rotation.x = $fx.getParam("rotationX")
  camera.rotation.y = $fx.getParam("rotationY")
  camera.rotation.z = $fx.getParam("rotationZ")

  controls.target = new THREE.Vector3(
    $fx.getParam("lookAtX"),
    $fx.getParam("lookAtY"),
    $fx.getParam("lookAtZ"),
  );

  controls.update()

  const composer = new EffectComposer( renderer )
  composer.setSize( sizes.width, sizes.height )
  composer.addPass( new RenderPass( scene, camera ) )

  const effectFilm = new FilmPass( $fx.rand(), ($fx.rand() * 0.1), 648, false )
  composer.addPass( effectFilm )

  
  if($fx.rand() > 0.9) {
    effectOutline = new OutlinePass( new THREE.Vector2( sizes.width, sizes.height ), scene, camera )
    effectOutline.edgeStrength = $fx.rand() * 3
    effectOutline.edgeGlow = $fx.rand()
    effectOutline.edgeThickness = $fx.rand() * 3
    effectOutline.pulsePeriod = $fx.rand() * 5
    composer.addPass( effectOutline )
    outlineEnabled = true
  }

  let pixel = false
  let bloom = false
  if($fx.rand() > 0.9) {
    const effectPixel = new RenderPixelatedPass( $fx.rand() * 10, scene, camera )
    effectPixel.setPixelSize( 6 )
    effectPixel.pixelAlignedPanning = true
    composer.addPass( effectPixel )
    pixel = true
  }
  if($fx.rand() > 0.9) {
    const effectBloom = new UnrealBloomPass( new THREE.Vector2( sizes.width, sizes.height ), 1.5, 0.4, 0.35 )
    composer.addPass( effectBloom )
    bloom = true
  }

  /**
   * Lights
   */
  const lightIntesity = ($fx.rand() * 14) + 1
  const spotLight = new THREE.SpotLight( 0x999999, lightIntesity )
  spotLight.position.set( 0, 15, 5 )
  scene.add( spotLight )

  RectAreaLightUniformsLib.init()
  const rectLight = new THREE.RectAreaLight( 0xff00ff, 100, $fx.getParam("rectLightWidth"), $fx.getParam("rectLightHeight") )
  rectLight.rotateY( Math.PI )

  rectLight.position.set(0, 0, $fx.getParam("rectLightPosition"))
  rectLight.lookAt(0, 0, 0)
  scene.add( rectLight )
  const rectLightHelper = new RectAreaLightHelper( rectLight )
  scene.add( rectLightHelper )

  // Light values
  let maxRed = $fx.rand() > 0.9 ? Math.floor($fx.rand() * 128) + 128 : 50
  let maxGreen = $fx.rand() > 0.9 ? Math.floor($fx.rand() * 128) + 128 : 50
  let maxBlue = $fx.rand() > 0.9 ? Math.floor($fx.rand() * 128) + 128 : 50

  /**
   * Stars
   */
  scene.add(createStars())
  scene.add(createNebula(maxRed, maxGreen, maxBlue))

  /**
   * More Stars
   */

  const loader = new GLTFLoader()
  let mixer
  loader.load( './astro.glb', function ( gltf ) {

    const model = gltf.scene
    model.rotateY( Math.PI )
    model.position.y = -1.8
    scene.add( model )


    model.traverse((child) => {
      if(child.isMesh && child.name === 'mandible' && $fx.rand() > 0.95) {
        child.material = new THREE.MeshNormalMaterial({
          transparent: true,
          opacity: 0.6,
        })
      }
      if(child.isMesh && child.name === 'Mesh_2_2') {
        if($fx.rand() > 0.5) {
          child.material = new THREE.MeshPhysicalMaterial({ 
            color: 0x9e9995,
            metalness: 1,
          })
        } else {
          child.material = new THREE.PointsMaterial({
            size: 1,
            sizeAttenuation: true,
          })
        }
      }
    })

    if($fx.rand() > 0.97) {
      model.traverse((child) => {
        if(child.isMesh) {
          child.material = new THREE.MeshPhysicalMaterial({
            transparent: true,
            opacity: 0.6,
            transmission: 0.9,
            ior: 1.1,
          })
        }
      })
    }

    mixer = new THREE.AnimationMixer( model )
    mixer.clipAction( gltf.animations[ 0 ] ).play()

    if(outlineEnabled) {
      effectOutline.selectedObjects = [model]
    }

    animate()

  }, undefined, function ( e ) {

    console.error( e )

  } )

  $fx.features({
    'Outline': outlineEnabled,
    'Pixel': pixel,
    'Bloom': bloom,
    'Intensity': maxBlue + maxGreen + maxRed,
    'Matrix': camera.position.z + camera.position.x + camera.position.y,
  })

  const clock = new THREE.Clock()

  function animate() {
    requestAnimationFrame(animate)

    controls.update()

    updateCameraParams(
      camera.position.x, camera.position.y, camera.position.z,
      camera.rotation.x, camera.rotation.y, camera.rotation.z,
      controls.target.x, controls.target.y, controls.target.z
    )

    rectLight.color = new THREE.Color(`rgb(${Math.floor(Math.random() * maxRed)}, ${Math.floor(Math.random() * maxGreen)}, ${Math.floor(Math.random() * maxBlue)})`)
    
    const delta = clock.getDelta()
    if ( mixer ) mixer.update( delta )

    composer.render()
  }

  function updateCameraParams(
    positionX, positionY, positionZ,
    rotationX, rotationY, rotationZ ) {
    $fx.emit("params:update", {
      positionX: positionX,
      positionY: positionY,
      positionZ: positionZ,
      rotationX: rotationX,
      rotationY: rotationY,
      rotationZ: rotationZ,
      lookAtX: controls.target.x,
      lookAtY: controls.target.y,
      lookAtZ: controls.target.z,
    })
  }

  window.addEventListener("resize", () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    composer.setSize(sizes.width, sizes.height)

    renderer.setSize(sizes.width, sizes.height)
  })

  window.addEventListener('keydown', (e) => {
    if(e.key === 'q') {
      rectLight.position.z += 0.05
    } else if(e.key === 'w') {
      rectLight.position.z -= 0.05
    } else if(e.key === 'a') {
      rectLight.width += 0.5
    } else if(e.key === 's' && rectLight.width > 0.0) {
      rectLight.width -= 0.5  
    } else if(e.key === 'z') {
      rectLight.height += 0.5
    } else if(e.key === 'x' && rectLight.height > 0.0) {
      rectLight.height -= 0.5  
    }
    $fx.emit("params:update", {
      rectLightWidth: rectLight.width,
      rectLightHeight: rectLight.height,
      rectLightPosition: rectLight.position.z,
    })
  })

  $fx.on(
    "params:update",
    () => {},
    () => {}
  )
}